(function() {
    'use strict';

    angular
        .module('cog.shared.customer')
        .controller('ApiHistoryController', ApiHistoryController);

    /* @ngInject */
    function ApiHistoryController($stateParams,  $filter, $state, CogApiServiceProvider: ICogApiServiceProvider, appSettings, moment, $mdMedia, $scope) {
        var gtsm = $mdMedia("gt-sm");
        var vm = this;
        vm.Pages = 0;
        vm.ShortDate = ShortDate;
        vm.FormatAdjustment = FormatAdjustment;
        vm.back = gotoFigures;
        vm.sumRR = sumRR;
        vm.loader = false;
        vm.apiError = false;
        vm.casinoTotal = 0;
        vm.TotalWagers = 0;
        vm.isBM = CogApiServiceProvider.is_BM();
        vm.HistoryGame = '';
        vm.getCasinoSummary = getCasinoSummary;
        vm.getCasinoDetail = getCasinoDetail;
        vm.getDataPage = getDataPage;        
        vm.query = { Page:1, PageSize:500, TotalItemCount:0};
        activate();

        function activate() {
            vm.daySelected = $stateParams.historyDay;           
            getDataPage(vm.query.Page);            
        }

        function getDataPage(page) {            
            if (vm.loader) return;
            vm.loader = true;
            CogApiServiceProvider.apiAccService().getHistoryDay(vm.daySelected, vm.query.Page)
                .success(function (response, status) {
                if (status == 200) {
                    
                    vm.Pages = Math.ceil(response.wagers.TotalItemCount / response.wagers.PageSize);
                    vm.query.Page = response.wagers.Page;
                    vm.query.TotalItemCount=response.wagers.TotalItemCount;
                    vm.PageSize = response.wagers.PageSize;                    
                    formatData(response);                         
                    vm.data = response;
                }
                else
                    vm.apiError = true;
            })
                .error(function (error) {
                vm.apiError = true;
            }).finally(function () {
                vm.loader = false;
            });
        }

        function formatData(resp) {                
            var TotalWagers=0;       
            vm.casinoTotal = getCasinoTotal(resp);
            angular.forEach(resp.wagers.Items, function (item, i) {
                angular.forEach(item.Wagers, function (w, i) {
                    if (!w.IsFreePlay || (w.IsFreePlay && w.HeaderOutcome == 'W'))
                        TotalWagers += w.AmountLost > 0 ? (w.AmountLost * -1) : w.AmountWon;
                    angular.forEach(w.Details, function (d, k) {
                        if (d.Description.toLowerCase().indexOf("win game") >= 0 || d.Description.toLowerCase().indexOf("wins game") >= 0) {
                            d.PeriodDescription = "Game";
                        }
                    });
                });
            });
            vm.TotalWagers = TotalWagers;
        }
        function getCasinoTotal(resp) {
            var total = 0;
            if (resp && resp.casino) {
                for (var i = 0; i < resp.casino.figures.length; i++)
                    total += resp.casino.figures[i].FigureAmount;
            }
            return total;
        }
        function ShortDate(input) {
            return $filter('date')(input, 'MM/dd/yyyy');
        }
        function FormatAdjustment(amount) {
            if (parseInt(amount)<0)
                return "-$" + (amount * -1);
            else
                return "$" + amount;
        }

        function gotoFigures() {
            var stateStr = 'cog.default.customer-figures';
            if (CogApiServiceProvider.is_BM())
                stateStr = 'bm.default.figures';
            var weekId = ($stateParams.weekId && !isNaN($stateParams.weekId) && $stateParams.weekId > 1) ? $stateParams.weekId : 1; // 1 = prev week
            $state.go(stateStr, { weekId: $stateParams.weekId });
        }

        function sumRR(wagers) {
            var acum:number = 0;
            angular.forEach(wagers, function (w, key) {
                acum += (w.HeaderOutcome == 'L') ? (w.AmountLost * -1) : w.AmountWon;
            });
            return acum;
        }

        function getCasinoSummary(date) {
            var promise = CogApiServiceProvider.apiAccService().getCasinoGameHistory(date);
            promise.then(function (resp) {
                if (resp != null) {
                    vm.HistoryGame = resp;
                    totalValues(resp);
                }
            });
        }

        function totalValues(HistoryGameResult) {
            let totalRisk = 0;
            let totalplayed = 0;
            angular.forEach(HistoryGameResult.data, function (gamble, key) {
                totalRisk += gamble.TOTAL_RISK;
                totalplayed += gamble.TOTAL_WON_LOST;
            });
            vm.totalRisk = totalRisk;
            vm.totalplayed = totalplayed;
        }

        function getCasinoDetail(event, data) {
            var td = angular.element(event.target).closest("md-toolbar").next(".CasinoDet");
            if (data.expanded) {
                var url = appSettings.cogCasino + "InternetGamingControl/Members/";
                url += "GamesHistory.aspx?";
                url += "i=" + data.PLAYER_ID;
                url += "&n=" + CogApiServiceProvider.apiAccService().getAccount().toUpperCase();
                url += "&d=" + moment(data.START_TIME).format('MM/DD/YYYY');
                url += "&gp=" + data.GAME_PLAY_ID;
                var ifr = angular.element("<iframe scrolling='no' width='850' height='500'></iframe>");
                if(!gtsm) 
                    ifr = angular.element("<iframe scrolling='yes' width='850' height='500'></iframe>");
                ifr.appendTo(td).load(function () {
                    /*    var contents = angular.element(this).contents();
                        contents.find(".title").remove();
                        contents.find("#lblReportTitle").closest("tr").remove();
                        contents.find("#lblMessage").closest("tr").remove();
                        contents.find(".timg").removeAttr("background");
                        var h = contents.height();
                        contents.css("height",h);*/
                }).attr("src", url);
            }
            else
                td.empty();
        }

        $scope.$watch(function() { return $mdMedia('gt-sm'); }, function(val) { gtsm = val; });
    }
})();
